export default __webpack_public_path__ + "images/logoTheOrganicPharmacy.d83809905a6a1dc45a94d542c1325079.svg"